module.exports = __webpack_public_path__ + "img/fu3.417ac596.png";